/**
 * A dónde ir cuando la interacción OIDC ya no sirve (venció a los 10 minutos o ya se usó: la portada quedó abierta
 * mucho rato, o el «atrás» del navegador). Nunca un callejón sin salida (GUIA §3.1):
 *
 * - Con sesión del portal la persona ya ingresó: se vuelve a abrir la app (`webUrl/?tenant=`), que sin sesión propia
 *   empieza otro ingreso y la sesión del portal lo termina sin pedir nada.
 * - Sin sesión, al ingreso: la portada de la entidad con la cortina de la app, o la de Datalog (la negra) si quien
 *   ingresaba en este navegador es superadministrador.
 *
 * `app` y `entidad` viajan en la URL de la interacción (`interactionPath`) porque una interacción vencida ya no dice
 * de qué app ni de qué entidad era.
 */
export interface FallbackInput {
  hasSession: boolean;
  superadmin: boolean;
  app: string | null;
  entidad: string | null;
  /** Dirección web de la app, si se conoce (catálogo público). */
  webUrl: string | null;
}

export const EXPIRED = 'expired';

export function interactionFallback({ hasSession, superadmin, app, entidad, webUrl }: FallbackInput): string {
  if (hasSession) {
    if (!webUrl) return '/';
    const url = new URL(webUrl.replace(/\/$/, '') + '/');
    if (entidad) url.searchParams.set('tenant', entidad);
    return url.href;
  }
  const q = new URLSearchParams();
  if (entidad && !superadmin) q.set('entidad', entidad);
  if (app) q.set('app', app);
  q.set('error', EXPIRED);
  return `/ingreso?${q.toString()}`;
}

/** La interacción con su contexto (app y, salvo para el superadministrador, entidad), para `volver`. */
export function interactionPath(uid: string, app: string, entidad: string | null, superadmin: boolean): string {
  const q = new URLSearchParams({ app });
  if (entidad && !superadmin) q.set('entidad', entidad);
  return `/interaccion/${uid}?${q.toString()}`;
}
